module.exports = __webpack_public_path__ + "static/img/ministry-of-justice-foreigners.262e37e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/ministry-of-justice-foreigners.jpg
// module id = 5GbO
// module chunks = 0